import { render, staticRenderFns } from "./unit-rates.vue?vue&type=template&id=b42eadf8&scoped=true&"
import script from "./unit-rates.vue?vue&type=script&lang=js&"
export * from "./unit-rates.vue?vue&type=script&lang=js&"
import style0 from "./unit-rates.vue?vue&type=style&index=0&id=b42eadf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42eadf8",
  null
  
)

export default component.exports